var map = {
	"./balloon-blue.png": 93866,
	"./balloon-green.png": 11913,
	"./balloon-pink.png": 21798,
	"./balloon-purple.png": 77164,
	"./balloon-yellow.png": 70314,
	"./balloons-orange.png": 88177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50274;